import React from 'react';
import Modal from './ui/Modal.jsx';

const ExamHistoryModal = ({ examHistory = [], savedExams = [], onRetake, onClose }) => {
    const formatDate = (d) => {
        try {
            if (!d) return '';
            const dateVal = typeof d === 'number' ? d : (typeof d?.toMillis === 'function' ? d.toMillis() : Date.parse(d));
            return new Date(dateVal || Date.now()).toLocaleString();
        } catch { return ''; }
    };

    return (
        <Modal title="Completed Exams" onClose={onClose} size="lg">
            <div className="mt-1 grid gap-5">
                <div>
                    <h3 className="text-sm font-semibold text-slate-200 mb-2">Saved Exams</h3>
                    {savedExams.length > 0 ? (
                        <ul className="divide-y divide-white/5 rounded-xl overflow-hidden ring-1 ring-white/10 bg-slate-900/60">
                            {savedExams.map((ex) => (
                                <li key={ex.id} className="flex items-center gap-3 px-4 py-3">
                                    <div className="flex-1">
                                        <div className="text-slate-200 text-sm font-medium">{ex.title || 'Untitled Exam'}</div>
                                        <div className="text-slate-400 text-xs">{formatDate(ex.createdAt)}</div>
                                    </div>
                                    {typeof onRetake === 'function' && (
                                        <button
                                            className="inline-flex items-center gap-2 rounded-xl px-3 py-1.5 text-xs text-white bg-violet-600"
                                            onClick={() => onRetake(ex.id)}
                                        >
                                            Retake
                                        </button>
                                    )}
                                </li>
                            ))}
                        </ul>
                    ) : (
                        <p className="text-sm text-slate-400">No saved exams yet.</p>
                    )}
                </div>

                <div>
                    <h3 className="text-sm font-semibold text-slate-200 mb-2">Past Scores</h3>
                    {examHistory.length > 0 ? (
                        <ul className="divide-y divide-white/5 rounded-xl overflow-hidden ring-1 ring-white/10 bg-slate-900/60">
                            {examHistory.map((entry) => (
                                <li key={entry.id} className="flex items-center gap-3 px-4 py-3">
                                    <span className="inline-flex items-center justify-center h-8 w-12 rounded-lg bg-violet-600/20 text-violet-300 text-sm font-semibold">{entry.score}%</span>
                                    <div className="flex-1">
                                        <div className="text-slate-200 text-sm font-medium">{entry.title}</div>
                                        <div className="text-slate-400 text-xs">{formatDate(entry.date)}</div>
                                    </div>
                                </li>
                            ))}
                        </ul>
                    ) : (
                        <p className="text-sm text-slate-400">No exam history yet.</p>
                    )}
                </div>
            </div>
            <div className="mt-6 flex justify-end">
                <button type="button" onClick={onClose} className="inline-flex items-center gap-2 rounded-xl px-4 py-2 text-sm text-slate-200 bg-slate-800/70 hover:bg-slate-800 ring-1 ring-white/10">Back</button>
            </div>
        </Modal>
    );
};

export default ExamHistoryModal;


